<template>
  <div class="d-flex" id="wrapper">
    <div class="greenBar">
      <div
        class="navbar-toggler"
        id="menu-toggle"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <img
          src="assets/images/nav-01.svg"
          alt="Toggle Menu"
          title="Toggle Menu"
        />
      </div>
      <div class="powerSwitch"><a v-on:click="logout" title="Logout"></a></div>
    </div>

    <div class="bgBonus border-right" id="sidebar-wrapper">
      <div class="logo">
        <router-link v-bind:to="dashboard" title="BONUS ME logo">
          <!--<img
            src="assets/images/logo-white.png"
            width="905"
            height="150"
            alt="BONUS ME logo"
          />-->
          <img
            src="brand-logo-white.png"
            width="905"
            height="150"
            alt="BONUS ME logo"
          />
        </router-link>
      </div>

      <div class="toSpend">
        <span class="toSpendTitle">Available to Spend</span>
        <span class="toSpendAmt">£{{ balance }}</span>
      </div>

      <!-- Without CMS -->
      <div v-if="isCmsUsed === false" class="list-group list-group-flush">
        <router-link
          v-bind:to="myBonusesPageRoute"
          class="list-group-item list-group-item-action bgBonus"
          title="My Bonuses"
          >My Bonuses</router-link
        >
        <router-link
          v-bind:to="allTransactionsRoute"
          class="list-group-item list-group-item-action bgBonus"
          title="View All Transactions"
          >View all Transactions</router-link
        >
        <router-link
          v-bind:to="limitsRoute"
          class="list-group-item list-group-item-action bgBonus"
          title="Fees &amp; Limits"
          >Fees &amp; Limits</router-link
        >
        <router-link
          v-bind:to="conditionsRoute"
          class="list-group-item list-group-item-action bgBonus"
          title="Terms &amp; Conditions"
          >Terms &amp; Conditions
        </router-link>
        <router-link
          v-bind:to="reportRoute"
          class="list-group-item list-group-item-action bgBonus"
          title="Report Card Lost/Stolen"
          >Report Lost/Stolen</router-link
        >
        <router-link
          v-bind:to="freezeCard"
          class="list-group-item list-group-item-action bgBonus"
          title="Freeze Card"
          >Freeze Card</router-link
        >
        <router-link
          v-bind:to="myVehicle"
          class="list-group-item list-group-item-action bgBonus"
          title="My Vehicle"
          >My Vehicle</router-link
        >
        <router-link
          v-bind:to="privacyRoute"
          class="list-group-item list-group-item-action bgBonus"
          title="Privacy Policy"
          >Privacy Policy</router-link
        >
      </div>

      <!-- With CMS -->
      <div v-if="isCmsUsed === true" class="list-group list-group-flush">
        <router-link
          v-if="cmsMenu.isMyBonusesActive === true"
          v-bind:to="myBonusesPageRoute"
          class="list-group-item list-group-item-action bgBonus"
          title="My Bonuses"
          >{{ cmsMenu.myBonusesMenuLabel }}</router-link
        >
        <router-link
          v-if="cmsMenu.isTransactionsActive === true"
          v-bind:to="allTransactionsRoute"
          class="list-group-item list-group-item-action bgBonus"
          title="View All Transactions"
          >{{ cmsMenu.transactionsMenuLabel }}</router-link
        >
        <router-link
          v-if="cmsMenu.isFeesAndLimitsActive === true"
          v-bind:to="limitsRoute"
          class="list-group-item list-group-item-action bgBonus"
          title="Fees &amp; Limits"
          >{{ cmsMenu.feesAndLimitsMenuLabel }}</router-link
        >
        <router-link
          v-if="cmsMenu.isConditionsActive === true"
          v-bind:to="conditionsRoute"
          class="list-group-item list-group-item-action bgBonus"
          title="Terms &amp; Conditions"
          >{{ cmsMenu.conditionsMenuLabel }}
        </router-link>
        <router-link
          v-if="cmsMenu.isReportActive === true"
          v-bind:to="reportRoute"
          class="list-group-item list-group-item-action bgBonus"
          title="Report Card Lost/Stolen"
          >{{ cmsMenu.reportMenuLabel }}</router-link
        >
        <router-link
          v-if="cmsMenu.isFreezeCardActive === true"
          v-bind:to="freezeCard"
          class="list-group-item list-group-item-action bgBonus"
          title="Freeze Card"
          >{{ cmsMenu.freezeCardMenuLabel }}</router-link
        >
        <router-link
          v-if="cmsMenu.isMyVehicleActive === true"
          v-bind:to="myVehicle"
          class="list-group-item list-group-item-action bgBonus"
          title="My Vehicle"
          >{{ cmsMenu.myVehicleMenuLabel }}</router-link
        >
        <router-link
          v-if="cmsMenu.isPrivacyPolicyActive === true"
          v-bind:to="privacyRoute"
          class="list-group-item list-group-item-action bgBonus"
          title="Privacy Policy"
          >{{ cmsMenu.privacyPolicyMenuLabel }}</router-link
        >
      </div>
      <div class="footer">
        <span class="profileName">{{ firstName }} {{ lastName }}</span>
        <span class="profileAction">
          <router-link v-if="isCmsUsed === false" v-bind:to="profileEditRoute">
            Edit profile and preferences
          </router-link>
          <router-link
            v-if="isCmsUsed === true && cmsMenu.isMyProfileActive === true"
            v-bind:to="profileEditRoute"
          >
            {{ cmsMenu.myProfileMenuLabel }}
          </router-link>
        </span>
      </div>
    </div>

    <!-- Page Content -->
    <div id="page-content-wrapper">
      <nav class="navbar navbar-expand-lg mobile-nav">
        <div class="logo">
          <router-link
            v-bind:to="dashboard"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            title="BONUS ME logo"
          >
            <!--
            <img
              src="assets/images/logo-white.png"
              width="905"
              height="150"
              alt="BONUS ME logo"
            />
            -->
            <img
              src="brand-logo-white.png"
              width="905"
              height="150"
              alt="BONUS ME logo"
            />
          </router-link>
        </div>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <!-- Without CMS -->
          <ul
            v-if="isCmsUsed === false"
            class="navbar-nav ml-auto mt-2 mt-lg-0"
          >
            <li class="nav-item">
              <router-link
                class="nav-link"
                v-bind:to="myBonusesPageRoute"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                title="My Bonuses"
                >My Bonuses</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-bind:to="allTransactionsRoute"
                title="View all Transactions"
                >View all Transactions</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-bind:to="limitsRoute"
                title="Fees &amp; Limits"
                >Fees &amp; Limits</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-bind:to="conditionsRoute"
                title="Terms &amp; Conditions"
                >Terms &amp; Conditions</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-bind:to="reportRoute"
                title="Report Card Lost or Stolen"
                >Report Lost/Stolen</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-bind:to="freezeCard"
                title="Freeze Card"
                >Freeze Card</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-bind:to="myVehicle"
                title="My Vehicle"
                >My Vehicle</router-link
              >
            </li>
            <li>
              <router-link
                class="nav-link"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-bind:to="privacyRoute"
                title="Privacy Policy"
                >Privacy Policy</router-link
              >
            </li>
            <li>
              <a v-on:click="logout" class="nav-link" title="Log out"
                >Log out</a
              >
            </li>
          </ul>

          <!-- With CMS -->
          <ul v-if="isCmsUsed === true" class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li v-if="cmsMenu.isMyBonusesActive === true" class="nav-item">
              <router-link
                class="nav-link"
                v-bind:to="myBonusesPageRoute"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                title="My Bonuses"
                >{{ cmsMenu.myBonusesMenuLabel }}</router-link
              >
            </li>
            <li v-if="cmsMenu.isTransactionsActive === true" class="nav-item">
              <router-link
                class="nav-link"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-bind:to="allTransactionsRoute"
                title="View all Transactions"
                >{{ cmsMenu.transactionsMenuLabel }}</router-link
              >
            </li>
            <li v-if="cmsMenu.isFeesAndLimitsActive === true" class="nav-item">
              <router-link
                class="nav-link"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-bind:to="limitsRoute"
                title="Fees &amp; Limits"
                >{{ cmsMenu.feesAndLimitsMenuLabel }}</router-link
              >
            </li>
            <li v-if="cmsMenu.isConditionsActive === true" class="nav-item">
              <router-link
                class="nav-link"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-bind:to="conditionsRoute"
                title="Terms &amp; Conditions"
                >{{ cmsMenu.conditionsMenuLabel }}</router-link
              >
            </li>
            <li v-if="cmsMenu.isReportActive === true" class="nav-item">
              <router-link
                class="nav-link"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-bind:to="reportRoute"
                title="Report Card Lost or Stolen"
                >{{ cmsMenu.reportMenuLabel }}</router-link
              >
            </li>
            <li v-if="cmsMenu.isFreezeCardActive === true" class="nav-item">
              <router-link
                class="nav-link"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-bind:to="freezeCard"
                title="Freeze Card"
                >{{ cmsMenu.freezeCardMenuLabel }}</router-link
              >
            </li>
            <li v-if="cmsMenu.isMyVehicleActive === true" class="nav-item">
              <router-link
                class="nav-link"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-bind:to="myVehicle"
                title="My Vehicle"
                >{{ cmsMenu.myVehicleMenuLabel }}</router-link
              >
            </li>
            <li v-if="cmsMenu.isPrivacyPolicyActive === true">
              <router-link
                class="nav-link"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                v-bind:to="privacyRoute"
                title="Privacy Policy"
                >{{ cmsMenu.privacyPolicyMenuLabel }}</router-link
              >
            </li>
            <li>
              <a v-on:click="logout" class="nav-link" title="Log out"
                >Log out</a
              >
            </li>
          </ul>
        </div>
      </nav>
      <router-view />
    </div>

    <!-- /#page-content-wrapper -->
    <div class="bottom-bar">
      <div class="row">
        <div class="col-sm-2 mobRing">
          <a href="#"><i class="fas fa-life-ring"></i></a>
        </div>
        <div class="col-sm-8 mobAvSpend">
          <div class="toSpend">
            <span class="toSpendTitle">Available to Spend</span>
            <span class="toSpendAmt">£{{ balance }}</span>
          </div>
        </div>
        <div class="col-sm-2 mobAcct">
          <router-link
            v-bind:to="profileEditRoute"
            title="Edit profile and preferences"
            ><i class="fas fa-user"></i
          ></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import routes from "@/constants/routes";
import actions from "@/store/authentication/actions";

export default {
  props: ["toggle"],
  created() {
    this.pagesRoute = routes.PAGES;
    this.reportRoute = routes.REPORT;
    this.profileEditRoute = routes.PROFILE;
    this.conditionsRoute = routes.CONDITIONS;
    this.limitsRoute = routes.LIMITS;
    this.allTransactionsRoute = routes.TRANSACTIONS;
    this.myBonusesPageRoute = routes.BONUSES;
    this.freezeCard = routes.FREEZECARD;
    this.myVehicle = routes.MYVEHICLE;
    this.dashboard = routes.DASHBOARD;
    this.privacyRoute = routes.PRIVACY;
  },
  methods: {
    mobileToggle: function() {
      this.isMobileMenuActive = !this.isMobileMenuActive;
    },
    logout: async function() {
      await this.$store.dispatch(actions.LOGOUT);
    }
  },
  mounted() {
    $("#menu-toggle").click(function(e) {
      e.preventDefault();
      $("#wrapper").toggleClass("toggled");
    });
  },
  computed: {
    isCmsUsed: {
      get() {
        return this.$store.state.cms.isCmsUsed;
      }
    },
    cmsMenu: {
      get() {
        return this.$store.state.cms.cmsMenu;
      }
    },
    isMenuActive: {
      get() {
        return this.$store.state.settings.isMenuActive;
      }
    },
    isMobileMenuActive: {
      get() {
        return this.$store.state.settings.isMobileMenuActive;
      },
      set(value) {
        this.$store.commit("updateIsMobileMenuActiveMutation", value);
      }
    },
    isActive: {
      get() {
        return this.$store.state.settings.isMenuActive;
      },
      set(value) {
        this.$store.commit("updateIsMenuActiveMutation", value);
      }
    },
    firstName: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.user?.firstName;
      }
    },
    lastName: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.user?.lastName;
      }
    },
    balance: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.card?.balance.toFixed(
          2
        );
      }
    }
  }
};
</script>
